export default function ReviewItem(props){
    console.log(props)
    return(
        <div>
            <p>{props.review}</p>
        </div>
    )
}